import { render } from "./PinModalAddWarning.vue?vue&type=template&id=213d3413"
import script from "./PinModalAddWarning.vue?vue&type=script&lang=js"
export * from "./PinModalAddWarning.vue?vue&type=script&lang=js"
script.render = render

export default script